export * from './primary-topic-modal.component';


// WEBPACK FOOTER //
// ./src/app/shared/components/metadata-menu/topic/primary-topic-modal/index.ts